<!--
 * @Author       : qixiao
 * @Date         : 2023-05-13 16:04:29
 * @LastEditors  : qixiao
 * @LastEditTime : 2023-05-13 16:04:52
 * @FilePath     : \hzs-Houtai\src\views\Agricultural\index.vue
 * @Description  : 
 * 
-->
<template>
    <router-view />
  </template>
  
  <script>
  export default {
    // name: "Setting",
  };
  </script>